import {Component, OnInit, ChangeDetectionStrategy, Input} from '@angular/core';

@Component({
  selector: 'terra-limit-line-item',
  templateUrl: './limit-line-item.component.html',
  styleUrls: ['./limit-line-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LimitLineItemComponent implements OnInit {
  /**
   * Title for this section
   */
  @Input() title: string;

  /**
   * Usage in the period
   */
  @Input() usage: number;

  /**
   * The limit for the period
   */
  @Input() limit: number;


  constructor() { }

  ngOnInit(): void {
  }

  get barValue(): number {
    return (this.usage / this.limit) * 100;
  }

}
